
let intro = "Former high school teammates Kuramochi Youichi and Miyuki Kazuya find themselves back together at Meiji University, dealing with the pressures of being top-tier athletes while trying to figure out life off the field." +
    "<br><br>Kuramochi is all about keeping things simple—until a dating app throws his emotional stability out of the window. Meanwhile, Miyuki, the team’s captain and baseball prodigy, struggles to keep his cool as he faces his past, his future, and his complicated feelings for the only person he's being willing to yield control to. " +
    "<br><br>This story is about more than just baseball—it's about navigating friendship, love, and figuring out who you really are when the game’s over and the crowd is gone."


export const STORY = {
    url: "https://archiveofourown.org/works/45155977",
    nume_url:"https://x.com/nume_x/status/1782887284209287300",
    title: "it was you",
    intro: intro,
    buttons: ["author: nodo", "rating: E", "status: ongoing"]
}